import React, {useEffect, useState} from "react";

import {useDispatch, useSelector} from "react-redux";
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
// import ReactPivot from "react-pivot";
import PivotTableUI from 'react-pivottable/PivotTableUI';
import 'react-pivottable/pivottable.css';
import Aggr from 'react-pivottable/PivotTableUI'
import TableRenderers from 'react-pivottable/TableRenderers';
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';

// create Plotly renderers via dependency injection
// const PlotlyRenderers = createPlotlyRenderers(Plot);

const useStyles = makeStyles(theme => ({
    dashboardSection: {
        // padding: "5px"
    },
}));


const ListaOSPivotTable = ({
                     rows
                          }) => {
    const classes = useStyles();

    const [show, setShow] = useState(false);
    const [ estadoPivot, setEstadoPivot ] = useState({
        rows: ['medida', 'banda', 'largura'],
        plotlyOptions: {width: 650, height: 500},
        plotlyConfig: {},
    });
    const st = useSelector(state => state);
    console.log("REDUX STATE", st);
    const etapas = useSelector(state => state.stations.etapas);
    const periodMin = useSelector(state => state.filter.periodMin);
    const periodMax = useSelector(state => state.filter.periodMax);

    const dispatch = useDispatch();


    // const ptdimensions = [
    //     { value: "ordemServico", title: "OrdemServico"},
    //     { value: "medida", title: "Medida"},
    //     { value: "fabricante", title: "Fabricante"}
    // ];

   // const preRows = ['medida', 'banda', 'r262'];
    {/*<ReactPivot*/}
    {/*     rows={rows}*/}
    {/*     dimensions={ptdimensions}*/}
    {/*     reduce={ptreduce}*/}
    {/*     calculations={ptcalculations}*/}
    {/*     hideRows={hideRows}*/}
    {/*/>*/}


  //   console.log("ROWS =>", rows);


    var count = function(data, rowKey, colKey) {
        return {
            count: 0,
            push: function(record) { this.count++; },
            value: function() { return this.count; },
            format: function(x) { return x; },
        };
    };

    const aggr={
        "Teste": count()
    }

    const renderers = Object.assign({}, TableRenderers);
    const keyNames = Object.keys(renderers);
    let nRender = [];
    keyNames.map( p => {
        if ( ["Table",].includes(p)) {
            nRender[p] = renderers[p];
        }
    }  )

    //console.log("RENDERERS =>", renderers);
    //console.log("RENDERERS Table =>", renderers["Table"]);
    //console.log("NEW RENDER =>", nRender);

    return (
        <div>
                    <PivotTableUI
                        data={rows}
                        {...estadoPivot}

                        locale="fr"
                        renderers={nRender}

                        onChange={s => setEstadoPivot(s)}
                    />
        </div>
    )

}

export default ListaOSPivotTable;
